'use strict';

import angular from 'angular';

export default function($http, $parse, toastr) {
	'ngInject';

	return {
		link: postLink,
		scope: {
			data: '<',
			context: '<',
		},
	};

	function postLink(scope, element, attrs) {
		if (!attrs.url) {
			throw 'Generic buttons require a `url`';
		}
		element.on('click', (e) => {
			e.preventDefault();
			if (attrs.confirmationMessage && !confirm(attrs.confirmationMessage)) {
				return;
			}
			$http({
				url: attrs.url,
				method: attrs.method || 'POST',
				data: scope.data,
			}).then((response) => {
				if (attrs.checkResponse && !$parse(attrs.checkResponse)(scope, {$response: response})) {
					if (attrs.errorMessage) {
						toastr.error(attrs.errorMessage);
					}
					$parse(attrs.onError)(scope, {$error: response});
					return;
				}
				if (attrs.successMessage) {
					toastr.success(attrs.successMessage);
				}
				$parse(attrs.onSuccess)(scope, {$response: response});
				if (attrs.successUrl) {
					window.location.href = attrs.successUrl;
				}
			}, (error) => {
				console.error(error);
				if (attrs.errorMessage) {
					toastr.error(attrs.errorMessage);
				}
				$parse(attrs.onError)(scope, {$error: error});
			})
		});
	}
}
